import { createRoot } from 'react-dom/client';

import ItineraryForm from './form.jsx';
import Itinerary from './itinerary.jsx';
import { Toaster } from 'react-hot-toast';

import './app.css';
import './../src/index.css';

function resolveToken(urlParams: URLSearchParams): string {
    const fromUrl = urlParams.get('token');
    if (fromUrl) {
        return fromUrl;
    }

    const fromEnv = import.meta.env.VITE_WEMAP_TOKEN;
    if (fromEnv) {
        return fromEnv;
    }

    return 'WEMAP_TOKEN';
}

export default function App() {

    const urlParams = new URLSearchParams(window.location.search);
    const emmid = urlParams.get('emmid') ? Number(urlParams.get('emmid')) : null;
    const graph = urlParams.get('network') || urlParams.get('graph');
    const devEnvironment = urlParams.get('devEnvironment') === 'true';
    const useGraphManagement = urlParams.get('graphmanagement') === 'true';
    const vpsMap = urlParams.get('vpsMap');
    const token = resolveToken(urlParams);
    
    if (!emmid || (!urlParams.has('network') && !urlParams.has('graph'))) {
        return (
            <ItineraryForm />
        );
    }

    return (<>
        <Itinerary
            environment={devEnvironment ? 'dev' : 'prod'}
            emmid={emmid}
            token={token}
            graph={graph}
            vpsMap={vpsMap}
            useGraphManagement={useGraphManagement}
        />
        <Toaster
            position="bottom-right" />
    </>
    );
}

document.title = 'Wemap - Itinerary tools';

createRoot(document.getElementById('app')!).render(<App />);
